import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "sw-cookie-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    if (!choice) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ value, ts: new Date().toISOString() })
    );
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-3 left-3 right-3 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[100] bg-[#0A0A0A]/95 backdrop-blur-xl border border-white/[0.08] shadow-[0_20px_60px_-10px_rgba(0,0,0,0.8)] p-4 md:p-7 animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <div className="absolute top-4 right-4 md:top-5 md:right-5 red-led" />
      <div className="absolute top-0 left-0 right-0 h-px hairline-red opacity-60" />

      <div className="flex items-center gap-3 mb-3 md:mb-4">
        <Cookie size={14} className="text-[#ff0033]" />
        <span className="text-[9px] md:text-[10px] tracking-[0.35em] uppercase text-zinc-400 font-bold">
          Cookies & Privatsphäre
        </span>
      </div>

      <h3 className="font-display font-black uppercase text-lg md:text-2xl tracking-tight leading-tight mb-2 md:mb-3">
        Wir respektieren deine Daten.
      </h3>

      <p className="text-[11px] md:text-xs text-zinc-400 leading-relaxed mb-4 md:mb-5">
        Nur technisch notwendige Cookies. Kein Tracking, keine Werbung, keine Drittanbieter.{" "}
        <Link
          to="/datenschutz"
          className="text-white underline decoration-[#ff0033]/60 hover:decoration-[#ff0033] underline-offset-2"
          data-testid="cookie-banner-link-privacy"
        >
          Mehr
        </Link>
        .
      </p>

      <div className="flex flex-row gap-2 md:gap-3">
        <button
          type="button"
          onClick={() => decide("declined")}
          data-testid="cookie-banner-decline"
          className="flex-1 text-[9px] md:text-[10px] tracking-[0.25em] md:tracking-[0.3em] uppercase font-bold border border-white/15 text-zinc-300 hover:text-white hover:border-white/30 px-3 md:px-5 py-2.5 md:py-3 transition-all"
        >
          Nur Notwendige
        </button>
        <button
          type="button"
          onClick={() => decide("accepted")}
          data-testid="cookie-banner-accept"
          className="group relative flex-1 inline-flex items-center justify-center gap-2 bg-white text-black px-3 md:px-5 py-2.5 md:py-3 text-[9px] md:text-[10px] font-bold tracking-[0.25em] md:tracking-[0.3em] uppercase overflow-hidden hover:shadow-[0_0_24px_rgba(255,0,51,0.4)] transition-shadow"
        >
          <span className="relative z-10 group-hover:text-white transition-colors">
            Akzeptieren
          </span>
          <span className="absolute inset-0 bg-[#ff0033] translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
